import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import { updatePreviousLocation } from '../legacy/store/appReducer';
import {
  checkAuthentication,
  clearResetIdleTime,
} from '../legacy/containers/Auth';

const AuthenticatedRoute = ({
  dispatch,
  location,
  authorizationType,
  component: Component,
  ...routeProps // contains redux state
}) => {
  const isAuthenticated = dispatch(checkAuthentication());
  if (!isAuthenticated) {
    clearResetIdleTime();
    // dispatch(updateLoginError(LOGIN_ERROR_MESSAGES.SESSION_TIMEOUT))
    dispatch(updatePreviousLocation(location));
  }

  return (
    <Route
      {...routeProps}
      render={props => {
        if (isAuthenticated) {
          return <Component {...props} authorizationType={authorizationType} />;
        }

        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

const ConnectedAuthenticatedRoute = connect(
  state => ({
    authorizationType: state.auth.authorizationType,
  }),
  dispatch => ({ dispatch }),
)(AuthenticatedRoute);
export default ConnectedAuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/auth/ConnectedAuthenticateRoute.jsx